document.addEventListener('DOMContentLoaded', function() {
    const button = document.querySelector('.toggle-btn');
    const content = document.querySelector('.toggle-content');
    const arrow = document.querySelector('.arrow');

    button.addEventListener('click', function() {
        content.classList.toggle('active');
        arrow.classList.toggle('active');
    });
});